function InvoicesController($scope) {
  'ngInject';

  $scope.$emit('account-settings:active', 'invoices');
}

export { InvoicesController };
